import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Panel } from 'react-bootstrap';
import { Form, FormGroup, FormControl, InputGroup } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

class CreateSetForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      selected: [{name: ''}]
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const exerciseForm = this.exerciseFormControl.getInstance();
    const weight = ReactDOM.findDOMNode(this.weightFormControl);
    const reps = ReactDOM.findDOMNode(this.repsFormControl);

    let exercise = {};
    // create new exercise of existing one wasn't selected
    if(exerciseForm.state.selected.length === 0) {
      exercise = this.props.createExercise({
        name: exerciseForm.state.text
      })
    // set exercise to selected
    } else {
      exercise = exerciseForm.state.selected[0];
    }

    const newSet = {
      exerciseKey: exercise.key,
      weight: Number.parseFloat(weight.value),
      reps: Number.parseFloat(reps.value),
      timeStamp: Date.now()
    }

    this.props.createSet(newSet);
    this.setState({
      selected: [exercise]
    });
  }

  render() {
    const exercises = Object.keys(this.props.exercises)
                            .map(key => this.props.exercises[key]);

    return(
      <Panel>
        <Form onSubmit={this.handleSubmit}>
          <FormGroup>
            <Typeahead
              placeholder="Exercise"
              selected={this.state.selected}
              options={exercises}
              labelKey="name"
              ref={(control) => this.exerciseFormControl = control}
            />
            <InputGroup>
              <FormControl
                type="number"
                placeholder="Weight lifted"
                ref={(control) => this.weightFormControl = control }
                required
              />
              <InputGroup.Addon>lbs</InputGroup.Addon>
            </InputGroup>
            <InputGroup>
              <FormControl
                type="number"
                placeholder="Number of reps"
                ref={(control) => this.repsFormControl = control }
                required
              />
              <InputGroup.Addon>reps</InputGroup.Addon>
            </InputGroup>
          </FormGroup>
          <Button type="submit" bsStyle="primary" block>Submit</Button>
        </Form>
      </Panel>
    );
  }
}

CreateSetForm.propTypes = {
  createSet: React.PropTypes.func.isRequired,
  createExercise: React.PropTypes.func.isRequired,
  exercises: React.PropTypes.object.isRequired
}

export default CreateSetForm;


// WEBPACK FOOTER //
// ./src/components/CreateSetForm.jsx